import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import SignatureCanvas from 'react-signature-canvas';
import Resizer from "react-image-file-resizer";
import LabelInfo from '../LabelInfo';
import LabelInput from '../LabelInput';
import signIcon from '../../assets/icon-signature.svg';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.scss';
import {FormattedMessage} from "react-intl";

const MAX_WIDTH = 200;
const MAX_HEIGHT = 200;
const COMPRESSION_FORMAT = 'PNG';
const QUALITY = 100;
const ROTATION = 0;

const FieldSignature = ({
                          fieldId,
                          label,
                          info,
                          containerStyles = null,
                          ...rest
                        }) => {
  let signatureRef = null;

  const handleInput = (form, field) => () => {
    if (signatureRef !== null) {
      new Promise(() => {
        signatureRef.getTrimmedCanvas().toBlob((file) => {
          Resizer.imageFileResizer(
            file,
            MAX_WIDTH,
            MAX_HEIGHT,
            COMPRESSION_FORMAT,
            QUALITY,
            ROTATION,
            (uri) => {
              form.setFieldValue(field.name, uri);
            },
            "base64"
          );
        })
      }).catch(console.error)
    }
  };

  const clear = (form, field) => () => {
    signatureRef.clear(); //signatureRef will set to null after setSignature
    form.setFieldValue(field.name, null);
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, form, meta}) => (
        <div className={classnames(styles.canvasContainer, containerStyles)}>
          <div className={styles.labelContainer}>
            <LabelInput label={label}/>
            <LabelInfo
              label={(
                <FormattedMessage
                  id='common.form.signature.clear'
                  defaultMessage='Clear'
                />
              )}
              className={styles.remove}
              onClick={clear(form, field)}
            />
          </div>
          <div className={classnames(styles.canvasWrapper)}>
            <div className={styles.icon}>
              <img src={signIcon} alt="signIcon"/>
            </div>
            <SignatureCanvas
              penColor='black'
              canvasProps={{
                className: classnames(styles.canvas, {[styles.errorBorder]: meta.error && meta.touched})
              }}
              ref={ref => signatureRef = ref}
              onEnd={handleInput(form, field)}
              {...rest}
            />
          </div>
        </div>
      )}
    </Field>
  )
};

FieldSignature.propTypes = {
  fieldId: PropTypes.string.isRequired,
  label: PropTypes.node,
  containerStyles: PropTypes.string,
};

export default FieldSignature;
